import React, {useState, useEffect} from 'react'

import "./Users.css"
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import axios from 'axios';
import ValidationMessage from '../../shared/validationmessage/ValidationMessage';

const model = {
  modulename: "User Editor"
};

const UserEditor = (props) => {

  const [userRole, setUserRole] = useState(localStorage.getItem("userrole"));
  const [userCompany, setUserCompany] = useState(localStorage.getItem("usercompany"));

  /* data handling */
  const data = props.data.data;
  const [Id, setId] = useState(data.Id);
  const [FullName, setFullName] = useState(data.FullName);
  const [Designation, setDesignation] = useState(data.Designation);
  const [Email, setEmail] = useState(data.Email);
  const [Age, setAge] = useState(data.Age);
  const [Experience, setExperience] = useState(data.Experience);
  const [Gender, setGender] = useState(data.Gender);
  const [ManagerType, setManagerType] = useState(data.ManagerType);
  const [Nationality, setNationality] = useState(data.Nationality);
  const [Tenure, setTenure] = useState(data.Tenure);
  const [Location, setLocation] = useState(data.Location);
  const [RoleId, setRoleId] = useState(data.RoleId);
  const [Password, setPassword] = useState("");
  const [Function, setFunction] = useState(data.Function);

  const [image, setImage] = useState(axios.defaults.baseURL + '/' + data.Photo);
  const [file, setFile] = useState();

  /* exceoption handling */
    const defaultValidation = {
      FullName: [],
      Designation: [],
      Email: [],
      Age: [],
      Experience: [],
      Gender: [],
      ManagerType: [],
      Nationality: [],
      Tenure: [],
      Location: [],
      RoleId: [],
      Password: [],
      Function: []
  };
  const [validations, setValidations] = useState(defaultValidation);

  const resetValidations=()=>{
    setValidations(defaultValidation);
    props.setErrors("");
  }

  const parseErrorResponse=(response)=>{
    if(response.data.errors){
      setValidations(response.data.errors);
    }
  }
  const handleCancelClick = () => {
    props.setEditorState({open: false, data: null});
  };

  const handleSubmitClick =(e)=>{
    e.preventDefault();

    var data = {
      Id: Id,
      FullName: FullName,
      Email: Email,
      Password: Password,
      Age: Age,
      Experience: Experience,
      Gender: Gender,
      ManagerType: ManagerType,
      Tenure: Tenure,
      RoleId: RoleId,
      Location: Location,
      Designation: Designation,
      Nationality: Nationality,
      Function: Function
    };

    props.setErrors("");

    axios.post('/users/save',data )
    .then(function (response) {
      if(response.data.status == "success"){
        setId(response.Id);
        uploadFileToServer();
      }
      else{
        props.setErrors(GetErrorMessage(response));
      }
    })
    .catch(function (error) {
      parseErrorResponse(error.response);
    });
  };

  const GetErrorMessage=(props)=>{
    console.log(props);
    if(!props){
      return "";
    }
    else if(props.data.message){
      return props.data.message;
    }
    else if(props.message){
      return props.message;
    }
    else{
      return "Some error occurred";
    }
  }

  const uploadFileToServer=()=>{
    if(file){
      const formData = new FormData();
      formData.append('Id', Id);
      formData.append('formFile', file);
      axios.post('/users/upload', formData,{
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })
      .then(function (response) {
        if(response.data.status == "success"){
          props.setEditorState({open: false, data: null});
          props.setPageState({loading: false});
        }
        else{
          props.setErrors(response.data.message);
        }
      })
      .catch(function (error) {
        props.setErrors(error.response.data.message);
      });
    }
    else{
      props.setEditorState({open: false, data: null});
      props.setPageState({loading: false});
    }
  }

  const handleFileChange =(e)=>{
    setImage(URL.createObjectURL(e.target.files[0]));
    setFile(e.target.files[0]);
  }

  return (
    <form className="form">
        <div className="mb-3">
            <img src={image} alt={FullName}/>
            <label className="upload-file">
            <input type="file" onChange={handleFileChange} className="d-none" /> Browser photo...          
            </label>
        </div>
        <div className="mb-3">
          <TextField
            required
            className="form-control"
            label="Full Name"
            value={FullName}
            onChange={e=> setFullName(e.target.value)}
          />
          <ValidationMessage field="FullName" errors={validations}/>
        </div>
        <div className="mb-3">
        <FormControl className="form-control">
            <InputLabel>Gender </InputLabel>
            <Select
              label="Gender "
              value={Gender}
              onChange={e=> setGender(e.target.value)}
            >
            <MenuItem value={1}>Male</MenuItem>
            <MenuItem value={2}>Female</MenuItem>
            <MenuItem value={3}>Other</MenuItem>
            <MenuItem value={4}>Prefer not to disclose</MenuItem>
          </Select>
          </FormControl>
          <small className="help-text">Gender detail will not be disclosed with anyone.</small>
          <ValidationMessage field="Gender" errors={validations}/>
        </div>
        <div className="mb-3">
          
        </div>
        <div className="mb-3">
        <TextField
            className="form-control"
            label="Age"
            value={Age}
            onChange={e=> setAge(e.target.value)}
            />
            <ValidationMessage field="Age" errors={validations}/>
        </div>
        <div className="mb-3">
        <TextField
              required
              className="form-control"
              label="Email"
              value={Email}
              onChange={e=> setEmail(e.target.value)
              }
              disabled={(Id == null || Id == "") ? false : true}
            />
          <ValidationMessage field="Email" errors={validations}/>
        </div>
        <div className="mb-3">
          
        </div>
        <div className="mb-3">
        <TextField
            label="Password"
            className="form-control"
            type="Password"
            onChange={e=> setPassword(e.target.value)}
          />
          <ValidationMessage field="Password" errors={validations}/>
          </div>
          <div className="mb-3">
          <FormControl className="form-control">
            <InputLabel>Role </InputLabel>
            <Select
              label="Role "
              value={RoleId}
              onChange={e=> setRoleId(e.target.value)}
            >
            { userRole == "Admin" && userCompany == null && <MenuItem value="3E8037B1-FCC5-4AEA-B9B7-AC6D5244FA83">Admin</MenuItem>}
            { userCompany != null && <MenuItem value="64E30FEB-554F-4A61-933E-FEB8048B071B">Company Admin</MenuItem>}
            { userCompany != null && <MenuItem value="C3C96E70-C417-4447-8976-5BC9F93B8045">Employee</MenuItem>}
          </Select>
        </FormControl>
        <ValidationMessage field="RoleId" errors={validations}/>
          </div>
          <div className="mb-3">
          <TextField
            label="Designation"
            className="form-control"
            value={Designation}
            onChange={e=> setDesignation(e.target.value)}
          />
          <ValidationMessage field="Designation" errors={validations}/>
          </div>
          <div className="mb-3">
          <FormControl className="form-control">
          <InputLabel>Manager Type </InputLabel>
          <Select
            label="Manage Type "
            value={ManagerType}
            onChange={e=> setManagerType(e.target.value)}
          >
          <MenuItem value={1}>First Time Manager</MenuItem>
          <MenuItem value={2}>Middle Manager</MenuItem>
          <MenuItem value={3}>Others</MenuItem>
        </Select>
      </FormControl>
      <ValidationMessage field="ManagerType" errors={validations}/>
          </div>
          <div className="mb-3">
          <TextField
            label="Experience"
            className="form-control"
            value={Experience}
            onChange={e=> setExperience(e.target.value)}
          />
          <ValidationMessage field="Experience" errors={validations}/>
          </div>
          <div className="mb-3">
          <TextField
            label="Tenure"
            className="form-control"
            value={Tenure}
            onChange={e=> setTenure(e.target.value)}
          />
          <ValidationMessage field="Tenure" errors={validations}/>
          </div>
          <div className="mb-3">
          <TextField
            label="Nationality"
            className="form-control"
            value={Nationality}
            onChange={e=> setNationality(e.target.value)}
          />
          <ValidationMessage field="Nationality" errors={validations}/>
          </div>
          <div className="mb-3">
          <TextField
            label="Location"
            className="form-control"
            value={Location}
            onChange={e=> setLocation(e.target.value)}
          />
          <ValidationMessage field="Location" errors={validations}/>
          </div>
          <div className="mb-3">
          <TextField
            label="Function"
            className="form-control"
            value={Function}
            onChange={e=> setFunction(e.target.value)}
          />
          <ValidationMessage field="Function" errors={validations}/>
          </div>
          <div className="btns">
            <button type="button" className="btn btn-primary" onClick={handleSubmitClick} >Save</button>&nbsp;
            <a className="btn btn-secondary" onClick={handleCancelClick}>Cancel</a>
          </div>
        </form>
  )
}

export default UserEditor

